import { Component, Vue } from 'vue-property-decorator'

// Components
import FieldText from '@/views/report/parts/fields/FieldText.vue'
import FieldTextarea from '@/views/report/parts/fields/FieldTextarea.vue'
import FieldNumber from '@/views/report/parts/fields/FieldNumber.vue'
import FieldDate from '@/views/report/parts/fields/FieldDate.vue'
import FieldList from '@/views/report/parts/fields/FieldList.vue'
import FieldNumeric from '@/views/report/parts/fields/FieldNumeric.vue'
import FieldBoolean from '@/views/report/parts/fields/FieldBoolean.vue'
import FieldSupport from '@/views/report/parts/fields/FieldSupport.vue'

@Component({
  components: {
    FieldText, FieldTextarea, FieldDate, FieldNumber, FieldList, FieldNumeric, FieldBoolean, FieldSupport
  }
})
export default class Field extends Vue {
  fieldType(type) {
    switch (type) {
      case 'text':
        return FieldText
        break
      case 'boolean':
        return FieldBoolean
        break
      case 'number':
        return FieldNumber
        break
      case 'numeric':
        return FieldNumeric
        break
      case 'list':
        return FieldList
        break
      case 'supports':
        return FieldSupport
        break
      case 'scan':
        return FieldText
        break
      // doesn't exists in API
      case 'note':
        return FieldTextarea
        break
      case 'map':
        return FieldText
        break
      case 'date':
        return FieldDate
        break
      case 'datetime':
        return FieldText
        break
    }
  }
}
